import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { BsFileEarmarkText } from "react-icons/bs";

function PaperCard(props) {
  return (
    <Card className="project-card-view">
      <Card.Body>
        <Card.Title>{props.name}</Card.Title>
        <Card.Subtitle className="mb-2 text-muted">
          <p style={{ color: "#c390ec" }}>{props.date}</p>
        </Card.Subtitle>
        <Card.Text>
          {props.refLink && (
            <Button variant="link" href={props.refLink} target="_blank">
              Reference
            </Button>
          )}
        </Card.Text>
        <Button variant="primary" target="_blank" href={props.link}>
          <BsFileEarmarkText /> &nbsp; Read Again
        </Button>
      </Card.Body>
    </Card>
  );
}

export default PaperCard;
